"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryOsmosisMintParmas = void 0;
const chain_query_1 = require("../../../chain-query");
const mobx_1 = require("mobx");
const unit_1 = require("@keplr-wallet/unit");
class ObservableQueryOsmosisMintParmas extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, `/osmosis/mint/v1beta1/params`);
        mobx_1.makeObservable(this);
    }
    get mintDenom() {
        var _a;
        return (_a = this.response) === null || _a === void 0 ? void 0 : _a.data.params.mint_denom;
    }
    get epochIdentifier() {
        var _a;
        return (_a = this.response) === null || _a === void 0 ? void 0 : _a.data.params.epoch_identifier;
    }
    get distributionProportions() {
        if (!this.response) {
            return {
                staking: new unit_1.Dec(0),
                poolIncentives: new unit_1.Dec(0),
                developerRewards: new unit_1.Dec(0),
            };
        }
        return {
            staking: new unit_1.Dec(this.response.data.params.distribution_proportions.staking),
            poolIncentives: new unit_1.Dec(this.response.data.params.distribution_proportions.pool_incentives),
            developerRewards: new unit_1.Dec(this.response.data.params.distribution_proportions.developer_rewards),
        };
    }
}
__decorate([
    mobx_1.computed
], ObservableQueryOsmosisMintParmas.prototype, "distributionProportions", null);
exports.ObservableQueryOsmosisMintParmas = ObservableQueryOsmosisMintParmas;
//# sourceMappingURL=params.js.map